// src/api/citizencast.js
// 프론트엔드에서 Cloudflare Pages Functions(/api/*) 를 호출하는 얇은 래퍼.
// 모든 응답은 { ok, ... } 또는 { ok:false, error } 규약을 따른다.

async function call(path, body) {
  let res;
  try {
    res = await fetch(`/api/${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body ?? {}),
    });
  } catch {
    // fetch 자체 실패 = 네트워크 끊김/오프라인/요청 차단
    throw new Error(`연결 실패 (${path}) — 네트워크 상태를 확인해주세요.`);
  }

  // 비-JSON 응답(Cloudflare 5xx/타임아웃 HTML 등)도 안전하게 처리
  const text = await res.text().catch(() => '');
  let data;
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    // 대개 무거운 단계(이미지/음성/렌더)가 서버 처리 시간을 초과해 Cloudflare 가 5xx HTML 을 반환한 경우.
    // 크레딧은 차감되지 않으니 잠시 후 다시 시도하면 대부분 성공한다.
    throw new Error(`서버 응답 지연 (${path}: ${res.status}) — 일시적인 처리 지연입니다. 잠시 후 다시 시도해주세요.`);
  }

  if (!res.ok || data.ok === false) {
    throw new Error(data?.error || `${path}: HTTP ${res.status}`);
  }
  return data;
}

export const api = {
  validateUrl:     (url)                        => call('validate-url', { url }),
  newsFeed:        (country, opts = {})         => call('news-feed', { country, ...opts }),
  filterComment:   (comment, language)          => call('filter-comment', { comment, language }),
  suggestComments: (payload)                    => call('suggest-comments', payload),
  generateScript:  (payload)                    => call('generate-script', payload),
  fetchMedia:      (scenes, country, targetLanguage) => call('fetch-media', { scenes, country, targetLanguage }),
  generateImage:   (scenes, country, fallbackKeywords) => call('generate-image', { scenes, country, fallbackKeywords }),
  searchImages:    (queries, country, articleSubject) => call('search-images', { queries, country, articleSubject }),
  synthesizeVoice: (payload)                    => call('synthesize-voice', payload),
  renderVideo:     (payload)                    => call('render-video', payload),
  deductCredit:    (uid, videoId)               => call('deduct-credit', { uid, videoId }),
  syncPlan:        (uid, email)                 => call('sync-plan', { uid, email }),
  customerPortal:  (uid)                        => call('customer-portal', { uid }),
  deleteAccount:   (uid)                        => call('delete-account', { uid }),
  processReferral: (uid)                        => call('process-referral', { uid }),
  adminDeleteUser: (adminEmail, targetEmail)    => call('admin-delete-user', { adminEmail, targetEmail }),
  changePlan:      (uid, targetTier)            => call('change-plan', { uid, targetTier }),
  collectNews:     (adminEmail, opts = {})      => call('collect-news', { adminEmail, ...opts }),
  genVideoMeta:    (payload)                    => call('gen-video-meta', payload),
  youtubeOauthStart: (adminEmail, channel)      => call('youtube-oauth-start', { adminEmail, channel }),
  youtubeStatus:   (adminEmail)                 => call('youtube-status', { adminEmail }),
  youtubeUpload:   (adminEmail, videoId, privacyStatus) => call('youtube-upload', { adminEmail, videoId, privacyStatus }),
  autoGenerate:    (adminEmail, country)        => call('auto-generate', { adminEmail, country }),
  adminDeleteVideo: (adminEmail, videoId)       => call('admin-delete-video', { adminEmail, videoId }),
};
